
export const ActivitiesSlider = () => {
  return (
    <section className="listing-section">
      <div className="divider-div">
        <div className="con-left">
          <div className="lisitng-div mg-topspo">
            <h3
              data-w-id="85db6317-f4b9-2aef-08dc-1877fd3fb20f"
              style={{ opacity: 1 }}
              className="lisitng-highlight"
            >
              We’ve got plans. You just show up.
            </h3>
            <h2
              data-w-id="85db6317-f4b9-2aef-08dc-1877fd3fb211"
              style={{ opacity: 1 }}
              className="listing-title"
            >
              Discover activities
              <br />
              that make you.
            </h2>
            <div
              data-w-id="85db6317-f4b9-2aef-08dc-1877fd3fb213"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="listing-des">
                Need to get out of your house and find out what your thing is? —
                we’ve got you covered. Browse activities by category, location, or
                vibe, and find your escape. It's all here, just waiting foryou to
                jump in.
              </p>
            </div>
            <a
              data-w-id="85db6317-f4b9-2aef-08dc-1877fd3fb216"
              style={{ opacity: 1 }}
              href="/categories"
              className="lisitng-btn w-inline-block"
            >
              <div className="text-block">Explore All</div>
            </a>
          </div>
        </div>
        <div
          data-w-id="1abef794-24c6-134b-5646-cb7b67599671"
          style={{ opacity: 1 }}
          className="con-right"
        >
          <div className="slider-image">
            <img
              src="/images/photo.svg"
              loading="lazy"
              alt=""
              className="image-2"
            />
          </div>
          <div className="slider-table">
            <img
              src="/images/user-polls-preview.webp"
              loading="lazy"
              sizes="(max-width: 1259px) 100vw, 1259px"
              srcSet="/images/user-polls-preview-p-500.webp 500w, /images/user-polls-preview-p-800.webp 800w, /images/user-polls-preview-p-1080.webp 1080w, /images/user-polls-preview.webp 1259w"
              alt=""
              className="image-3"
            />
          </div>
        </div>
      </div>
      <div className="slider-card-div">
        <div className="team-slider_component">
          <div className="w-embed">
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n@container (width < 40em) {\n\t.team-slider_cms_item.swiper-slide { width: calc(100% / 2); }\n}\n@container (width < 25em) {\n\t.team-slider_cms_item.swiper-slide { width: calc(100% / 1.2); }\n}\n"
              }}
            />
          </div>
          <div className="team-slider_cms_wrap swiper">
            <div className="team-slider_cms_list swiper-wrapper">
              <div className="team-slider_cms_item swiper-slide">
                <a
                  data-w-id="835cadce-0633-e245-adf2-ba37806816ca"
                  href="/#"
                  className="scroll-card w-inline-block"
                >
                  <div className="media-wrapper">
                    <img
                      sizes="(max-width: 540px) 100vw, 540px"
                      srcSet="/images/360_F_930602998_Kha1LVMuNeOVgaLobwPyz5eJbUW4xzWj-p-500.jpg 500w, /images/360_F_930602998_Kha1LVMuNeOVgaLobwPyz5eJbUW4xzWj.jpg 540w"
                      alt=""
                      src="/images/360_F_930602998_Kha1LVMuNeOVgaLobwPyz5eJbUW4xzWj.jpg"
                      loading="lazy"
                      className="full-image"
                    />
                  </div>
                  <div className="content-wrapper">
                    <div className="text-wrapper">
                      <div className="date-card-div">
                        <div className="card__content">
                          <img
                            sizes="(max-width: 1024px) 100vw, 1024px"
                            srcSet="/images/formula_1-logo-brandlogos.net_-p-500.png 500w, /images/formula_1-logo-brandlogos.net_.png 1024w"
                            alt=""
                            src="/images/formula_1-logo-brandlogos.net_.png"
                            loading="lazy"
                            className="image"
                          />
                          <div className="card__desc">
                            <h1 className="heading">Formula Karting</h1>
                            <p className="card-des">
                              Your fast lane to fun starts here at the Mills Pune.
                              No Limits, Just Speed.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-w-id="835cadce-0633-e245-adf2-ba37806816da"
                      className="grow-background"
                    />
                  </div>
                </a>
              </div>
              <div className="team-slider_cms_item swiper-slide">
                <a
                  data-w-id="835cadce-0633-e245-adf2-ba37806816dc"
                  href="/#"
                  className="scroll-card w-inline-block"
                >
                  <div className="media-wrapper">
                    <img
                      loading="lazy"
                      src="/images/trekking-poles-himalaya.avif"
                      alt=""
                      className="full-image"
                    />
                  </div>
                  <div className="content-wrapper">
                    <div
                      data-w-id="835cadce-0633-e245-adf2-ba37806816ec"
                      className="grow-background"
                    />
                    <div className="card__content">
                      <img
                        sizes="(max-width: 1593px) 100vw, 1593px"
                        srcSet="/images/MMYT-ca98a9f1-p-500.png 500w, /images/MMYT-ca98a9f1-p-800.png 800w, /images/MMYT-ca98a9f1-p-1080.png 1080w, /images/MMYT-ca98a9f1.png 1593w"
                        alt=""
                        src="/images/MMYT-ca98a9f1.png"
                        loading="lazy"
                        className="image"
                      />
                      <div className="card__desc">
                        <h1 className="heading">Trek the Himalayas</h1>
                        <p className="card-des-2">
                          Your fast lane to fun starts here at the Mills Pune. No
                          Limits, Just Speed.
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="team-slider_cms_item swiper-slide">
                <a
                  data-w-id="835cadce-0633-e245-adf2-ba37806816ee"
                  href="/#"
                  className="scroll-card w-inline-block"
                >
                  <div className="media-wrapper">
                    <img
                      sizes="(max-width: 1000px) 100vw, 1000px"
                      srcSet="/images/aos-paint-undergrad-p-500.jpg 500w, /images/aos-paint-undergrad-p-800.jpg 800w, /images/aos-paint-undergrad.jpg 1000w"
                      alt=""
                      src="/images/aos-paint-undergrad.jpg"
                      loading="lazy"
                      className="full-image"
                    />
                  </div>
                  <div className="content-wrapper">
                    <div
                      data-w-id="835cadce-0633-e245-adf2-ba37806816fe"
                      className="grow-background"
                    />
                    <div className="card__content">
                      <img
                        sizes="(max-width: 800px) 100vw, 800px"
                        srcSet="/images/Google__G__logo.svg-p-500.png 500w, /images/Google__G__logo.svg.png 800w"
                        alt=""
                        src="/images/Google__G__logo.svg.png"
                        loading="lazy"
                        className="image"
                      />
                      <div className="card__desc">
                        <h1 className="heading">Paint it up</h1>
                        <p className="card-des-2">
                          Your fast lane to fun starts here at the Mills Pune. No
                          Limits, Just Speed.
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="team-slider_cms_item swiper-slide">
                <a
                  data-w-id="835cadce-0633-e245-adf2-ba3780681700"
                  href="/#"
                  className="scroll-card w-inline-block"
                >
                  <div className="media-wrapper">
                    <img
                      sizes="(max-width: 800px) 100vw, 800px"
                      srcSet="/images/speechless--p-500.jpeg 500w, /images/speechless-.jpg 800w"
                      alt=""
                      src="/images/speechless-.jpg"
                      loading="lazy"
                      className="full-image"
                    />
                  </div>
                  <div className="content-wrapper">
                    <div className="text-wrapper">
                      <div className="date-card-div">
                        <h1 className="cards-date-num">21</h1>
                        <h4 className="heading-2">
                          September
                          <br />
                          2025
                          <br />
                        </h4>
                      </div>
                      <h4 className="heading-2 event-title">
                        International Public Health Conference at MPU
                        <br />
                      </h4>
                    </div>
                    <div
                      data-w-id="835cadce-0633-e245-adf2-ba3780681710"
                      className="grow-background"
                    />
                  </div>
                </a>
              </div>
              <div className="team-slider_cms_item swiper-slide">
                <a
                  data-w-id="835cadce-0633-e245-adf2-ba3780681712"
                  href="/#"
                  className="scroll-card w-inline-block"
                >
                  <div className="media-wrapper">
                    <img
                      sizes="(max-width: 800px) 100vw, 800px"
                      srcSet="/images/speechless--p-500.jpeg 500w, /images/speechless-.jpg 800w"
                      alt=""
                      src="/images/speechless-.jpg"
                      loading="lazy"
                      className="full-image"
                    />
                  </div>
                  <div className="content-wrapper">
                    <div className="text-wrapper">
                      <div className="date-card-div">
                        <h1 className="cards-date-num">21</h1>
                        <h4 className="heading-2">
                          September
                          <br />
                          2025
                          <br />
                        </h4>
                      </div>
                      <h4 className="heading-2 event-title">
                        International Public Health Conference at MPU
                        <br />
                      </h4>
                    </div>
                    <div
                      data-w-id="835cadce-0633-e245-adf2-ba3780681722"
                      className="grow-background"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="team-slider_layout">
            <div className="team-slider_bullet_wrap-2">
              <div className="team-slider_bullet_item-2 is-active" />
              <div className="team-slider_bullet_item-2" />
            </div>
            <div className="team-slider_btn_layout-2">
              <div className="team-slider_btn_element swiper-button-disabled is-prev">
                <button type="button" data-arrow="prev" className="arrow-2">
                  <div className="arrow-background" />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 20 20"
                    fill="none"
                    className="arrow-icon"
                  >
                    <path
                      d="M13.125 16.25L6.875 10L13.125 3.75"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <div className="team-slider_btn_element is-next">
                <button type="button" data-arrow="next" className="arrow-2">
                  <div className="arrow-background" />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 20 20"
                    fill="none"
                    className="arrow-icon"
                  >
                    <path
                      d="M6.875 3.75L13.125 10L6.875 16.25"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
